import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import { DialogContent, Grid, List, Paper, ListItem } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import { IJobFieldSettingsType, IJobFieldSettings } from 'wisestep-api';
import {
  WsDialog,
  WsTypography,
  WsTypoVariants,
  ControlledTextInput,
  WsButton,
} from 'wisestep-base';

import { HeaderBox } from '../components/HeaderBox';
export interface CustomizeJobStatusDialogProps {
  openDialog: boolean;
  closeDialog(): void;
  onChangeHandler: (data: IJobFieldSettingsType) => void;
  modifiedData?: Omit<
    IJobFieldSettings,
    'id' | 'workspaceId' | 'createdBy' | 'createdOn' | 'modifiedBy' | 'modifiedOn'
  >;
}
const CustomizeJobStatusDialog: FC<CustomizeJobStatusDialogProps> = ({
  openDialog,
  closeDialog,
  modifiedData,
  onChangeHandler,
}) => {
  const defaultData = {
    mandatory: true,
    hide: false,
    disabled: false,
    availableFields: ['FullTime', 'PartTime', 'PerDiem'],
    label: 'Job Status',
    selectedFields: [],
    selectedField: '',
  };
  const [jobStatusData, setJobStatusData] = useState<IJobFieldSettingsType>(defaultData);
  useEffect(() => {
    if (modifiedData?.jobStatusType) {
      const jobStatusTypeFormDefaultValues = modifiedData?.jobStatusType;
      setJobStatusData({ ...jobStatusTypeFormDefaultValues });
    }
  }, [modifiedData?.jobStatusType]);
  const [edit, setEdit] = useState<number>(-1);
  const defaultValues = {
    status: '',
  };
  const formOptions = {
    defaultValues: defaultValues,
  };
  const methods = useForm(formOptions);

  const { reset } = methods;
  const onChange = (index: number, data?: FieldValues) => {
    switch (index) {
      case 0:
        if (data?.status) {
          jobStatusData.availableFields.push(data.status);
        }
        break;
      case 1:
        if (data?.newStatus && data?.status !== data?.newStatus) {
          jobStatusData.availableFields[edit] = data?.newStatus;
        }
        break;
      case 2:
        jobStatusData.availableFields.splice(edit, 1);
        break;
    }
    const newStatusData = jobStatusData;
    setJobStatusData({ ...newStatusData });
    onChangeHandler({ ...newStatusData });
    setEdit(-1);
    reset();
  };
  return (
    <WsDialog openDialog={openDialog} size="small">
      <DialogContent>
        <HeaderBox>
          <WsTypography variant={WsTypoVariants.SUB_TITLE}>Add/Edit Job Status</WsTypography>
        </HeaderBox>
        <Grid container direction="column" xs={12} mt={2}>
          <Grid item xs={5} mb={1}>
            <FormProvider {...methods}>
              <form onSubmit={methods.handleSubmit((data: FieldValues) => onChange(0, data))}>
                <ControlledTextInput
                  name="status"
                  label="Add new Status"
                  sx={{ mr: '1vw', width: '85%', maxHeight: '1vw' }}
                  size="small"
                />
                <WsButton size="small" type="submit">
                  Save
                </WsButton>
              </form>
            </FormProvider>
          </Grid>

          <Grid item xs={10} mb={2}>
            <List dense>
              {jobStatusData.availableFields.map((e) => (
                <Paper
                  elevation={0}
                  sx={{
                    mb: '0.5vw',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                  key={e}
                >
                  <FormProvider {...methods}>
                    {edit !== jobStatusData.availableFields.indexOf(e) && (
                      <>
                        <ListItem>{e}</ListItem>
                        <WsButton
                          size="small"
                          fullWidth={false}
                          startIcon={<EditIcon />}
                          onClick={() => setEdit(jobStatusData.availableFields.indexOf(e))}
                        >
                          Edit
                        </WsButton>
                      </>
                    )}
                    {edit === jobStatusData.availableFields.indexOf(e) && (
                      <>
                        <ControlledTextInput
                          name="newStatus"
                          type="text"
                          label="New Status"
                          defaultValue={e}
                          sx={{ width: '65%' }}
                          size="small"
                        />
                        <WsButton
                          size="small"
                          fullWidth={false}
                          startIcon={<SaveIcon />}
                          onClick={methods.handleSubmit((data: FieldValues) => onChange(1, data))}
                        >
                          Save
                        </WsButton>
                        <WsButton
                          size="small"
                          fullWidth={false}
                          startIcon={<CloseIcon />}
                          onClick={() => onChange(2)}
                        >
                          Remove
                        </WsButton>
                      </>
                    )}
                  </FormProvider>
                </Paper>
              ))}
            </List>
          </Grid>

          <Grid item xs={12} display="flex" justifyContent="end">
            <WsButton onClick={() => closeDialog()}>Close</WsButton>
          </Grid>
        </Grid>
      </DialogContent>
    </WsDialog>
  );
};
export default CustomizeJobStatusDialog;
